import React from 'react'
import { CheckPicker, Tag } from 'rsuite'
import { getSearchableOrderStatuses } from '@@partner:helpers/order'

export interface OrderStatusesPickerProps {
  value: number[]
  onChange: (value: number[]) => void
  placeholder?: string
  size?: 'lg' | 'md' | 'sm' | 'xs'
}

const AVAILABLE_ORDER_STATUSES = getSearchableOrderStatuses()

export default function OrderStatusesPicker ({
  value,
  onChange,
  placeholder = 'Статусы заказа',
  size = 'sm'
}: OrderStatusesPickerProps) {
  return (
    <CheckPicker
      value={value}
      onChange={onChange}
      data={AVAILABLE_ORDER_STATUSES}
      searchable={false}
      placeholder={placeholder}
      valueKey="value"
      labelKey="label"
      size={size}
      block
      renderMenuItem={(label, item: any) => (
        <Tag key={item?.value} color={item?.color}>
          {label}
        </Tag>
      )}
    />
  )
}
